module.exports = __webpack_public_path__ + "static/media/xaki-dantela-bg-2.321b4139.jpg";